import { useTranslation } from 'react-i18next'; // Importing useTranslation hook

export interface TableRowData {
  code: string;
  description: string;
}

export function createTableData(
  code: string,
  description: string,
): TableRowData {
  return { code, description };
}

export const useTableData = () => {
  const { t } = useTranslation();

  const rows: TableRowData[] = [
    createTableData('$$address$$', t('tableData.address')),
    createTableData('$$comment$$', t('tableData.comment')),
    createTableData('$$userAddress$$', t('tableData.userAddress')),
    createTableData('$$userPostCode$$', t('tableData.userPostCode')),
    createTableData('$$userCity$$', t('tableData.userCity')),
    createTableData('$$company$$', t('tableData.company')),
    createTableData('$$coursename$$', t('tableData.courseName')),
    createTableData('$$coursereginfo$$', t('tableData.coursereginfo')),
    createTableData('$$date$$', t('tableData.date')),
    createTableData('$$date-old$$', t('tableData.dateOld')),
    createTableData('$$duration$$', t('tableData.duration')),
    createTableData('$$duration-old$$', t('tableData.durationOld')),
    createTableData('$$email$$', t('tableData.email')),
    createTableData('$$firstname$$', t('tableData.firstName')),
    createTableData('$$lastname$$', t('tableData.lastName')),
    createTableData('$$mobile$$', t('tableData.mobile')),
    createTableData('$$place$$', t('tableData.place')),
    createTableData('$$googlemapslink$$', t('tableData.googleMapsLink')),
    createTableData('$$price$$', t('tableData.price')),
    createTableData('$$priceinfo$$', t('tableData.priceInfo'))
  ];

  return { rows };
};
